import React, { useCallback, useContext, useMemo, useState } from 'react';

import { useCompanies as useCompaniesService } from 'services/companies';
import { useUserSelector } from 'hooks/useUser';

const CompanyContext = React.createContext(null);

export function CompanyContextProvider({ children }) {
  const {
    data: company = {},
    refetch: reloadCompany,
    isLoading: isCompanyLoading
  } = useCompaniesService({ enabled: true });
  const { user } = useUserSelector();
  const [isMortgageApplicationURLInClipboard, setIsMortgageApplicationURLInClipboard] =
    useState(false);

  const isSuperAdmin = useMemo(() => {
    return user?.user_id === company?.owner_user_id;
  }, [user, company]);

  const mortgageApplicationReferralLink = useMemo(
    () => `${process.env.REACT_APP_UPSCORE_URL}/p/${company?.short_id}/${user?.own_referral_id}`,
    [company?.short_id, user?.own_referral_id]
  );

  const copyToClipboardMortgageApplicationUrl = useCallback(() => {
    navigator.clipboard.writeText(mortgageApplicationReferralLink);
    setIsMortgageApplicationURLInClipboard(true);

    setTimeout(() => {
      setIsMortgageApplicationURLInClipboard(false);
    }, 1000);
  }, [mortgageApplicationReferralLink, setIsMortgageApplicationURLInClipboard]);

  return (
    <CompanyContext.Provider
      value={{
        company,
        reloadCompany,
        isCompanyLoading,
        isSuperAdmin,
        isMortgageApplicationURLInClipboard,
        copyToClipboardMortgageApplicationUrl,
        mortgageApplicationReferralLink
      }}
    >
      {children}
    </CompanyContext.Provider>
  );
}

export function useCompany() {
  const context = useContext(CompanyContext);

  if (!context) {
    throw new Error('useCompany must be used within a CompanyContextProvider');
  }

  return context;
}
